export default __webpack_public_path__ + "static/cert-icon-05-ef8c37aa97397cddacb11ae9adf0b653.png";